import { currentDevelopmentUIState } from './dev-ui-state';

export function getSpaceId() {
  return currentDevelopmentUIState.containerId;
}

export function getSpaceKey() {
  return currentDevelopmentUIState.containerKey;
}
